import type { GatewayCustomerService } from 'commonTypes/api/gatewayCustomerService';
import type { TOfferStatus } from 'constants/offer';
import { LOANS_STATUS, OFFER_STATUS } from 'constants/offer';

const LOANS_STATUS_TO_OFFER_STATUS: Partial<Record<GatewayCustomerService.TLoansOfferStatus, TOfferStatus>> = {
  [LOANS_STATUS.ACCEPTED]: OFFER_STATUS.ACCEPTED,
  [LOANS_STATUS.FAILED]: OFFER_STATUS.FAILED,
  [LOANS_STATUS.REFUSED]: OFFER_STATUS.REFUSED,
  [LOANS_STATUS.PREAPPROVED]: OFFER_STATUS.PREAPPROVED,
  [LOANS_STATUS.APPROVED]: OFFER_STATUS.APPROVED,
  [LOANS_STATUS.ISSUED]: OFFER_STATUS.ISSUED,
  [LOANS_STATUS.QUEUED]: OFFER_STATUS.QUEUED,
};

const OFFER_STATUS_TO_LOANS_STATUS: Partial<Record<TOfferStatus, GatewayCustomerService.TLoansOfferStatus>> = {
  [OFFER_STATUS.ACCEPTED]: LOANS_STATUS.ACCEPTED,
  [OFFER_STATUS.FAILED]: LOANS_STATUS.FAILED,
  [OFFER_STATUS.REFUSED]: LOANS_STATUS.REFUSED,
  [OFFER_STATUS.PREAPPROVED]: LOANS_STATUS.PREAPPROVED,
  [OFFER_STATUS.APPROVED]: LOANS_STATUS.APPROVED,
  [OFFER_STATUS.ISSUED]: LOANS_STATUS.ISSUED,
  [OFFER_STATUS.QUEUED]: LOANS_STATUS.QUEUED,
};

export const loansStatusToOfferStatusAdapter = (
  loansStatus: GatewayCustomerService.TLoansOfferStatus,
): TOfferStatus => {
  return LOANS_STATUS_TO_OFFER_STATUS[loansStatus] || OFFER_STATUS.NEW;
};

export const offerStatusToLoansStatusAdapter = (
  offerStatus: TOfferStatus,
): GatewayCustomerService.TLoansOfferStatus | undefined => {
  return OFFER_STATUS_TO_LOANS_STATUS[offerStatus];
};
